/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import history from 'Utility/history';
import formikReducers from './formik';
import enhancersReducer from './enhancers';
import portalModalReducer from './portalModalReducer';
import portalTemplateReducer from './portalTemplate';
import formReducer from './form';
import sharedReducer from './shared';
// @generator reducers:import

export const makeRootReducer = (asyncReducers) =>
	combineReducers({
		// @generator reducers:combine
		shared: sharedReducer,
		form: formReducer,
		portalTemplate: portalTemplateReducer,
		portalModal: portalModalReducer,
		enhancers: enhancersReducer,
		formik: formikReducers,
		router: connectRouter(history),
		...asyncReducers,
	});

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */

export const injectReducer = (store, { key, asyncReducer }) => {
	if (Reflect.has(store.asyncReducers, key)) return;
	// Reset injected Reducers
	store.asyncReducers = {};

	store.asyncReducers[key] = asyncReducer;
	store.replaceReducer(makeRootReducer(store.asyncReducers));
};

export default makeRootReducer;
